import { Component, OnInit } from '@angular/core';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-demande-resilisation',
  templateUrl: './demande-resilisation.component.html',
  styleUrls: ['./demande-resilisation.component.scss']
})
export class DemandeResilisationComponent implements OnInit {

  FILE_MAX_SIZE = this.configurationService.get().FILE.FILE_MAX_SIZE;
  FILE_ACCEPT_TYPE = this.configurationService.get().FILE.FILE_ACCEPT;
  EMAIL_PATTERN = this.configurationService.get().demande_resil.EMAIL_PATTERN;
  configuration = this.configurationService.get();
  MAX_FILE_SELECT = this.configurationService.get().demande_resil.FILE.FILE_LIMIT;
  public fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);


  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService, private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

}
